<template>
  <div class="clients">
    <button @click="hereAll" class="btn btn-danger">
      {{ "check_all" | setText("Отметить всех") }}
    </button>

    <table class="journal">
      <thead>
        <th>
          {{ "full_name" | setText("ФИО") }}
        </th>
        <th>
          {{ "here" | setText("Присутствие") }}
        </th>
        <th>
          {{ "estimates" | setText("Оценки") }}
        </th>
        <th align="right"></th>
      </thead>

      <tbody>
        <tr v-for="client in clients" :key="client.id">
          <td>
            {{ client.full_name | maxChar(30) }}
          </td>
          <td>
            <ul v-if="items.length" class="status_attendance">
              <li v-for="(item, key) in items" :key="key">
                <div>
                  <input
                    v-model="client.status"
                    @change="here(client)"
                    :id="'item_' + client.id + item.key"
                    :value="item.key"
                    :name="`${client.id}-status_attendance`"
                    type="radio"
                  />
                  <label :for="'item_' + client.id + item.key">
                    {{ `status_here_${item.key+1}` | setText(item.title) }}</label
                  >
                </div>
              </li>
            </ul>
          </td>
          <td>
            <rating
              v-model="client.ratings"
              :client="client"
              :lessonplan_id="lessonplan_id"
              :id="id"
              :defaultWork="defaultWork"
            >
            </rating>
          </td>
          <td align="right">
            <button
              @click="shopReport(client)"
              class="btn btn-sm btn-warning btn-icon"
            >
              <span class="ti-info"></span>
              {{ "rep" | setText("Жалоба") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <report :client_id="client_id" :discipline_id="discipline_id" />
  </div>
</template>

<script>
import { setHere, setReport, setHereAll } from "@/_api/apiPupil";
import rating from "@/components/Item/Timetable/Info/Rating";
import Report from "./Report.vue";

export default {
  created() {},
  data: () => ({
    client_id: null,
    items: [
      {
        key: "0",
        title: "Присутствует",
      },
      {
        key: "1",
        title: "Опоздал",
      },
      {
        key: "2",
        title: "Болеет",
      },
      {
        key: "3",
        title: "Неув.",
      },
      {
        key: "4",
        title: "По ув. причине",
      },
    ],
  }),
  methods: {
    setHere: setHere,
    setHereAll: setHereAll,
    setReport: setReport,
    here(client) {
      this.setHere(this.id, client);
    },
    hereAll() {
      this.setHereAll(this.id);
    },

    shopReport(client) {
      this.$modal.show("report");
      this.client_id = client.id;
    },
  },
  props: {
    clients: {
      default: [],
    },
    id: {
      default: null,
    },
    discipline_id: {
      default: null,
    },
    defaultWork: {
      default: null,
    },
    lessonplan_id: {
      default: null,
    },
  },
  computed: {},
  components: {
    rating,
    Report,
  },
};
</script>
<style lang="scss">
.clients {
  max-width: 100%;
  overflow-x: scroll;

  & table.journal {
    width: 100%;

    border-collapse: collapse;
    margin: 25px 0;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 400px;

    & > thead {
      tr,
      th {
        background-color: #009879;
        color: #ffffff;
        text-align: left;
      }
    }

    & th,
    td {
      padding: 12px 15px;

      &:first-child {
        min-width: 240px;
        max-width: 240px;
        width: 240px;
      }
    }

    & > tbody {
      tr {
        border-bottom: 1px solid #dddddd;

        &:nth-of-type(even) {
          background-color: #f3f3f3;
        }

        // &:last-of-type {
        //   //  border-bottom: 2px solid #009879;
        // }
      }
    }
  }

  div.rating {
    display: flex;
    align-items: center;

    & > ul {
      display: flex;
      align-items: center;
      margin-right: 10px;

      & > li {
        cursor: pointer;
        padding: 0;
        font-size: 20px;
        background: orange;
        display: flex;

        border-radius: 100%;
        margin-right: 10px;
        width: 35px;
        align-items: center;
        justify-content: center;
        height: 35px;

        & > span {
          color: #fff;
          display: block;
        }
      }
    }

    // & > button {
    // }
  }

  & ul.status_attendance {
    display: flex;
    flex-wrap: wrap;

    & > li {
      margin: 3px 10px 0 0;

      & > div {
        display: flex;
        justify-content: left;
        align-items: center;

        & > label {
          display: block;
          margin-left: 5px;
          margin-top: 0px;
        }

        // & > input {
        // }
      }
    }
  }
}
</style>
